import PagedElements from '@/models/paged/pagedelements';
import EntityListViewModel from '@/models/view/entitylistviewmodel';

export default class PagedEntities extends PagedElements<EntityListViewModel> {
    constructor(init?: Partial<PagedEntities>) { super(init); }
}
